export const SMART_REPLY_MENU_TEST_ID = 'smart-reply-menu';
